// Scan feedback — a short beep on a good scan, a low buzz (and a vibration
// where the device has one) on a rejected one. WebAudio is created lazily on
// the first scan, which always follows a user gesture, so autoplay policies
// allow it. Everything here is best-effort: no sound is never an error.

type AudioCtor = new () => AudioContext

let ctx: AudioContext | null = null

function audio(): AudioContext | null {
  if (typeof window === 'undefined') return null
  if (ctx) return ctx
  const w = window as unknown as { AudioContext?: AudioCtor; webkitAudioContext?: AudioCtor }
  const C = w.AudioContext || w.webkitAudioContext
  if (!C) return null
  try { ctx = new C() } catch { ctx = null }
  return ctx
}

function tone(freq: number, ms: number, type: OscillatorType): void {
  const a = audio()
  if (!a) return
  try {
    const osc = a.createOscillator()
    const gain = a.createGain()
    osc.type = type
    osc.frequency.value = freq
    gain.gain.value = 0.08
    osc.connect(gain)
    gain.connect(a.destination)
    osc.start()
    osc.stop(a.currentTime + ms / 1000)
  } catch { /* best-effort */ }
}

function vibrate(pattern: number | number[]): void {
  try {
    const n = (typeof navigator !== 'undefined' ? navigator : null) as (Navigator & { vibrate?: (p: number | number[]) => boolean }) | null
    n?.vibrate?.(pattern)
  } catch { /* best-effort */ }
}

export function beep(): void {
  tone(1320, 90, 'sine')
}

export function buzz(): void {
  tone(180, 260, 'square')
  vibrate([120, 60, 120])
}
